import React from "react";
import "./Task.css";
import Topbar from "../Topbar/Topbar";

const NewTask = () => {
  return (
    <div className="customer-scroll-stop">
      <Topbar />
      <div>
      <h3 className="px-2">My Task</h3>

      </div>
    </div>
  );
};

export default NewTask;
